import { BaseApi } from "../BaseApi";

const notificarReclamacionUrl = "/api/v1/websalud/primeraars/farmacard/notificareclamacionw";

const notificarReclamacion = (request) => {
  const { numeroSesion, requestData } = request;

  const headers = {
    accept: "text/plain",
    "Content-Type": "application/json",
  };

  if (numeroSesion) {
    headers["x-numero-sesion"] = numeroSesion;
  }

  return BaseApi.post(notificarReclamacionUrl, requestData, {
    headers,
  }).then((response) => response.data);
};

const exportedObject = {
  notificarReclamacion,
};

export default exportedObject;

